import { defineComponent } from 'vue'
import debounce from 'debounce';

export default defineComponent({
    name: 'googleMapSettingsStorageMixin',
    computed: {
        localStorageKey() {
            return `gmap-${Laravel.activeProject}`
        },
        mapTypeIdKey() {
            return `${this.localStorageKey}-mti`
        },
        centerKey() {
            return `${this.localStorageKey}-center`
        },
        zoomKey() {
            return `${this.localStorageKey}-zoom`
        },
        headingKey() {
            return `${this.localStorageKey}-heading`
        },
        tiltKey() {
            return `${this.localStorageKey}-tilt`
        }
    },
    methods: {
        debounceSaveCenter: debounce(function (map) {
            const center = map.getCenter();
            if (center) localStorage.setItem(this.centerKey, `${center.lng()},${center.lat()}`);
        }, 250),
        debounceSaveHeading: debounce(function (map) {
            const heading = map.getHeading();
            if (heading != null) localStorage.setItem(this.headingKey, heading);
        }, 250),
        debounceSaveTilt: debounce(function (map) {
            const tilt = map.getTilt();
            if (tilt != null) localStorage.setItem(this.tiltKey, tilt);
        }, 250)
    },
    watch: {
        googleMap(map) {
            if (!map) return

            let center = localStorage.getItem(this.centerKey)
            if (center) {
                const splitCoordinates = center.split(',')

                center = splitCoordinates?.length > 1 ? {
                    lng: +splitCoordinates[0],
                    lat: +splitCoordinates[1]
                } : null
            }
            const zoom = localStorage.getItem(this.zoomKey)
            const heading = localStorage.getItem(this.headingKey)
            const tilt = localStorage.getItem(this.tiltKey)

            /* https://developers.google.com/maps/documentation/javascript/overview#MapOptions */
            const mapOptions = {
                mapTypeId: localStorage.getItem(this.mapTypeIdKey),
                center: center ?? this.defaultCenter,
                zoom: zoom ? +zoom : 8,
                heading: heading ? +heading : null,
                tilt: tilt ? +tilt : null
            }

            Object.keys(mapOptions).forEach(key => {
                if (mapOptions[key] == null) {
                    delete mapOptions[key]
                }
            })

            if (Object.values(mapOptions).some((mapOptionValue => mapOptionValue != null))) {
                //console.log('setting map options', mapOptions)
                map.setOptions(mapOptions)
            }

            map.addListener('maptypeid_changed', () => {
                const mapTypeId = map.getMapTypeId()
                if (mapTypeId) localStorage.setItem(this.mapTypeIdKey, mapTypeId)
            })
            map.addListener('center_changed', () => {
                this.debounceSaveCenter(map);
            })
            map.addListener('zoom_changed', () => {
                const zoom = map.getZoom()
                if (zoom != null) localStorage.setItem(this.zoomKey, zoom)
            })
            map.addListener('heading_changed', () => {
                this.debounceSaveHeading(map);
            })
            map.addListener('tilt_changed', () => {
                this.debounceSaveTilt(map);
            })
        }
    }
})
